import { reroll } from "../components/PageSetRouter";

export default {
  homepageViaReferral(referralCode: string) {
    reroll(`/r/${referralCode}`);
  },
};
